<template>
    <div class="position-relative" :style="{'min-height': containerSize ? containerSize : size}">
        <moon-loader
            :class="{'absolute-center': withWrapper}"
            :loading="loading"
            :color="color"
            :size="size"></moon-loader>
    </div>
</template>

<script>

    import MoonLoader from 'vue-spinner/src/MoonLoader.vue'

    export default {
        name: 'MoonSpinner',
        components: {MoonLoader},

        props: {
            loading: {
                type: Boolean,
                required: true,
            },
            color: {
                type: String,
                required: false,
                default: '#00A07F'
            },
            size: {
                type: String,
                required: false,
                default: '60px'
            },
            containerSize: {
                type: String,
                required: false,
                deafult: ''
            },
            withWrapper: {
                type: Boolean,
                required: false,
                default: true
            }
        }
    }

</script>
